import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [

  {
    id: 1,
    label: 'general.allInstitutions',
    link: '/superadmin/institutions',
    roles: ['SuperAdmin'],
    icon: 'fas fa-bank',
  }, 
 
// Teachers

// { id: 10, label: 'general.settings', 
//     isTitle: true, roles: ['Teacher'] 
//   },

//     {
//       id: 11,
//       label: 'general.semesters',
//       link: '/teacher/semesters',
//       roles: ['Teacher'],
//       icon: 'fas fa-calendar',
//     },   
    
];
